import classNames from 'classnames/bind';
import { IItinerary } from 'common/types';
import usePriceGraph from 'hooks/usePriceGraph';
import { useState } from 'react';
import Chart from './chart';
import styles from './index.module.scss';
import Summary from './summary';
import Tooltip from './tooltip';

const cx = classNames.bind(styles);

const PERIOD = 60;

interface IProps {
  fareType: string;
  isDirect: boolean;
  itinerary: IItinerary[];
  minFare: number;
}

export default function PriceGraph({
  fareType,
  isDirect,
  itinerary,
  minFare,
}: IProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [includeEventFare, setIncludeEventFare] = useState(true);
  const searchKey = [
    fareType,
    itinerary
      .map(({ departureAirport, arrivalAirport, departureDate }) =>
        [departureDate, departureAirport, arrivalAirport].join(''),
      )
      .join(''),
  ].join('');
  const data = usePriceGraph({
    searchKey,
    includeEventFare,
    nonstop: isDirect,
    period: PERIOD,
  });

  if (!data) return null;

  const { averageLowestFare, fares } = data;
  return (
    <div className={cx('PriceGraph')}>
      <div className={cx('inner')}>
        <div className={cx('details')} aria-expanded={isOpen}>
          <div className={cx('summary')}>
            <div className={cx('title')}>
              <h5 className={cx('text')}>항공권 가격 추이 그래프</h5>
              <Tooltip areaCode="isr" period={PERIOD} />
            </div>
            <Summary
              averageLowestFare={averageLowestFare}
              currentMinFare={minFare}
            />
            <button
              className={cx('open')}
              type="button"
              data-event-nlog="click"
              data-event-area-code="isr.pricegraphopen"
              onClick={() => setIsOpen(true)}
            />
            <button
              className={cx('event_fare')}
              type="button"
              aria-checked={includeEventFare}
              data-event-nlog="click"
              data-event-area-code="isr.pricegraphcard"
              onClick={() => setIncludeEventFare(prev => !prev)}
            >
              카드요금
            </button>
          </div>
          <div className={cx('detail')}>
            {isOpen && <Chart areaCode="isr" fares={fares} period={PERIOD} />}
            <button
              className={cx('close')}
              type="button"
              data-event-nlog="click"
              data-event-area-code="isr.pricegraphclose"
              onClick={() => setIsOpen(false)}
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
